import {combineReducers} from 'redux';
import CreateNoteReducer from './create_note_reducer/CreateNoteReducer';
import PreviewNoteReducer from './preview_note_reducer/PreviewNoteReducer';

export default combineReducers({
  createNote: CreateNoteReducer,
  previewNote: PreviewNoteReducer,
});
